module.exports = __webpack_public_path__ + "img/received_packages.4fa87088.svg";